// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "BalanceAccountSettingsModule__textCenter__BuFJa";
export const table = "BalanceAccountSettingsModule__table__DJH+9";
export const tableInner = "BalanceAccountSettingsModule__tableInner__FOxzl";
export const headerRow = "BalanceAccountSettingsModule__headerRow__7z8eg";
export const white = "BalanceAccountSettingsModule__white__96uad";
export const headerCell = "BalanceAccountSettingsModule__headerCell__3PlsL";
export const responsiveTitle = "BalanceAccountSettingsModule__responsiveTitle__mib1P";
export const responsiveTitleText = "BalanceAccountSettingsModule__responsiveTitleText__toipc";
export const headerTitle = "BalanceAccountSettingsModule__headerTitle__KSk4Q";
export const sortingWrapper = "BalanceAccountSettingsModule__sortingWrapper__9zUSR";
export const withHelpText = "BalanceAccountSettingsModule__withHelpText__6yCai";
export const up = "BalanceAccountSettingsModule__up__jHyki";
export const down = "BalanceAccountSettingsModule__down__P6tzy";
export const body = "BalanceAccountSettingsModule__body__5o-Dk";
export const row = "BalanceAccountSettingsModule__row__mxrEd";
export const cell = "BalanceAccountSettingsModule__cell__PG-bK";
export const footer = "BalanceAccountSettingsModule__footer__36mS8";
export const paginatorWrapper = "BalanceAccountSettingsModule__paginatorWrapper__KPbGe";
export const pageSizeSelectorWrapper = "BalanceAccountSettingsModule__pageSizeSelectorWrapper__eKDt1";
export const tooltipIconWrapper = "BalanceAccountSettingsModule__tooltipIconWrapper__NxZI7";
export const debtsAccountDetails = "BalanceAccountSettingsModule__debtsAccountDetails__SCCac";
export const creditAccountDetails = "BalanceAccountSettingsModule__creditAccountDetails__dYD9K";
export const accountsTable = "BalanceAccountSettingsModule__accountsTable__wVuWa";
export const pointing = "BalanceAccountSettingsModule__pointing__-hadZ";
export const liveUpdatePreloader = "BalanceAccountSettingsModule__liveUpdatePreloader__PgKQR";
export const liveUpdatePreloaderText = "BalanceAccountSettingsModule__liveUpdatePreloaderText__uAnZ9";
export const emptyState = "BalanceAccountSettingsModule__emptyState__shYhk";
export const liveUpdatePreloaderIcon = "BalanceAccountSettingsModule__liveUpdatePreloaderIcon__1FTj-";
export const accountBadgeCell = "BalanceAccountSettingsModule__accountBadgeCell__nZi+h CommonRowMobile__spanRow__2pfr+ font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const visibleTwoColumnsUp = "BalanceAccountSettingsModule__visibleTwoColumnsUp__F8XMh";
export const lastUpdated = "BalanceAccountSettingsModule__lastUpdated__aFc--";